import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    overflow: none;\n\n    transition: max-height 0.4s ease;\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    float: right;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    flex: 1 1 100%;\n    margin: 0;\n    cursor: pointer;\n\n    user-select: none;\n\n    font-weight: ", ";\n    color: ", ";\n    border-bottom: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { H3 } from '../Typography';
import { Icon } from '../Icon';
export var StyledWrapper = styled.div(_templateObject());
export var StyledTitle = styled(H3)(_templateObject2(), function (props) {
  return props.theme.components.typography.config.fontWeight.medium;
}, function (props) {
  return props.theme.global.colors.primary;
}, function (props) {
  return props.theme.global.colors.primary;
});
export var StyledIcon = styled(Icon)(_templateObject3());
export var StyledContentWrapper = styled.div(_templateObject4(), function (props) {
  return props.isOpen ? "max-height: 1000px; overflow: none;" : "max-height: 0px; overflow: hidden;";
});